<template>
  <div>
    <FreeHeader v-if="showBurgerMenu" class="py-4">
      <template #leftAction>
        <button
          class="text-text-neutral-primary relative"
          type="button"
          @click="handleMenuClick"
        >
          <div
            v-if="showMenuBadge"
            class="bg-background-negative-primary absolute right-[2.5px] top-[2.5px] size-1.5 rounded-full"
          ></div>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M3.5 7c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 7.001ZM3.5 14c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 14.001ZM3.5 21c0-.644.522-1.166 1.167-1.166h18.666a1.167 1.167 0 1 1 0 2.333H4.667A1.167 1.167 0 0 1 3.5 21.001Z" clip-rule="evenodd"/></svg>
        </button>
      </template>
      <template #default>
        <h2 class="text-text-neutral-primary text-center text-lg font-semibold">
          {{ t('mainPageHeader.travel') }}
        </h2>
      </template>
      <template #rightAction>
        <button type="button" @click="handleCrossButtonClick">
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"><rect width="28" height="28" class="fill-background-neutral-tertiary" rx="14"/><path class="fill-static-white" fill-rule="evenodd" d="m14 12.586-3.48-3.48a1 1 0 0 0-1.414 1.414l3.48 3.48-3.48 3.48a1 1 0 0 0 1.414 1.414l3.48-3.48 3.48 3.48a1 1 0 1 0 1.414-1.414L15.414 14l3.48-3.48a1 1 0 1 0-1.414-1.414L14 12.586Z" clip-rule="evenodd"/></svg>
        </button>
      </template>
    </FreeHeader>
    <header v-else class="flex w-full items-center justify-between py-4">
      <h2 class="text-text-neutral-primary text-lg font-semibold">
        {{ t('mainPageHeader.travel') }}
      </h2>
      <div class="flex items-center gap-2">
        <slot name="rightExtra" />
        <button type="button" @click="handleCrossButtonClick">
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"><rect width="28" height="28" class="fill-background-neutral-tertiary" rx="14"/><path class="fill-static-white" fill-rule="evenodd" d="m14 12.586-3.48-3.48a1 1 0 0 0-1.414 1.414l3.48 3.48-3.48 3.48a1 1 0 0 0 1.414 1.414l3.48-3.48 3.48 3.48a1 1 0 1 0 1.414-1.414L15.414 14l3.48-3.48a1 1 0 1 0-1.414-1.414L14 12.586Z" clip-rule="evenodd"/></svg>
        </button>
      </div>
    </header>

    <ProfileLinksBottomSheet
      :search-app-type="searchAppType"
      @onStartLoading="emit('onStartLoading')"
      @onMyTicketsClick="emit('onMyTicketsClick')"
    >
      <template #[FlowType.TOURS]>
        <slot :name="FlowType.TOURS" />
      </template>
    </ProfileLinksBottomSheet>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import { controllerModel } from 'shared';

  import { freedomApp } from '../../../entities/freedom-app';
  import { FlowType } from '../../../shared/config';
  import { FreeHeader } from '../../../shared/ui';
  import { PROFILE_LINKS_BOTTOM_SHEET_NAME } from '../config';
  import ProfileLinksBottomSheet from './ProfileLinksBottomSheet.vue';

  withDefaults(
    defineProps<{
      searchAppType?: FlowType;
      showMenuBadge?: boolean;
      showBurgerMenu?: boolean;
    }>(),
    {
      searchAppType: FlowType.AVIA,
      showMenuBadge: false,
      showBurgerMenu: true,
    },
  );
  const emit = defineEmits<{
    onStartLoading: [];
    onMyTicketsClick: [];
    onMenuOpen: [];
  }>();
  const { t } = useI18n();
  const bottomSheet = controllerModel.useBottomSheet();

  const handleMenuClick = () => {
    emit('onMenuOpen');
    bottomSheet.show(PROFILE_LINKS_BOTTOM_SHEET_NAME);
  };

  const handleCrossButtonClick = () => {
    freedomApp.lib.backToApp();
  };
</script>

<i18n src="../config/locales.json"></i18n>
